import { CAMPAIGN_EDITOR_FORM_FIELDS } from 'modules/campaigns/editor/constants';
import { useCampaignAlertsContext } from 'modules/campaigns/editor/context';
import { useAlertsConflict } from 'modules/campaigns/editor/hooks/useAlertsConflict';
import { CampaignEditorFormState } from 'modules/campaigns/editor/types';
import { AlertsCaption } from 'modules/campaigns/lib/components/AlertsCaption';
import { EnabledAlertsList } from 'modules/campaigns/lib/components/EnabledAlertsList';
import styled from 'styled-components';
import { WarningText } from 'ui/formField';
import { pxToRem } from 'utils/convert';
import { ExpandableToggle } from './ExpandableToggle';

type EditableAlertsPropTypes = {
  isDisabled: boolean;
  tooltipContent: string;
};

const StyledWarningText = styled(WarningText)`
  margin: ${pxToRem(10)} 0 0 0;
`;

export const EditableAlerts = (props: EditableAlertsPropTypes) => {
  const alertsConflictMessage = useAlertsConflict();
  const { alertDetails } = useCampaignAlertsContext();
  return (
    <ExpandableToggle
      name={CAMPAIGN_EDITOR_FORM_FIELDS.CAMPAIGN_ALERTS_ENABLED as keyof CampaignEditorFormState}
      caption={<AlertsCaption />}
      {...props}
    >
      <EnabledAlertsList alertDetails={alertDetails} />
      {alertsConflictMessage.length > 0 && (
        <StyledWarningText>{alertsConflictMessage}</StyledWarningText>
      )}
    </ExpandableToggle>
  );
};
